var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEjectingMOonCertexQr(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    width: 490,
    height: 490,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M0 0h490v490H0z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 140 14)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 168 14)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 182 14)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 196 14)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 210 14)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 238 14)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 252 14)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 266 14)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 280 14)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 294 14)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 308 14)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 322 14)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 350 14)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 154 28)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 168 28)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 182 28)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 210 28)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 252 28)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 266 28)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 294 28)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 308 28)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 350 28)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 126 42)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 154 42)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 168 42)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 196 42)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 224 42)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 238 42)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 252 42)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 280 42)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 294 42)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 308 42)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 322 42)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 336 42)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 350 42)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 126 56)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 140 56)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 154 56)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 224 56)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 238 56)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 252 56)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 280 56)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 308 56)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 336 56)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 140 70)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 154 70)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 196 70)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 266 70)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 294 70)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 308 70)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 336 70)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 350 70)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 182 84)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 238 84)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 266 84)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 280 84)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 294 84)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 322 84)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 336 84)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 126 98)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 154 98)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 182 98)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 210 98)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 238 98)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 266 98)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 294 98)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 322 98)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 350 98)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 140 112)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 154 112)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 182 112)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 196 112)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 210 112)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 224 112)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 266 112)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 280 112)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 350 112)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 56 126)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 70 126)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 98 126)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 112 126)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 154 126)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 182 126)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 224 126)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 252 126)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 280 126)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 294 126)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 308 126)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 420 126)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 434 126)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 56 140)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 70 140)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 84 140)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 126 140)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 140 140)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 196 140)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 210 140)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 266 140)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 294 140)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 308 140)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 336 140)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 364 140)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 392 140)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 406 140)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 14 154)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 28 154)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 42 154)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 70 154)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 84 154)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 98 154)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 112 154)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 126 154)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 168 154)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 182 154)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 196 154)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 224 154)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 280 154)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 322 154)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 336 154)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 364 154)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 378 154)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 392 154)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 448 154)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 462 154)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 28 168)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 56 168)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 70 168)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 84 168)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 112 168)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 140 168)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 196 168)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 210 168)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 224 168)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 252 168)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 266 168)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 294 168)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 308 168)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 322 168)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 392 168)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 406 168)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 434 168)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 448 168)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 14 182)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 28 182)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 42 182)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 56 182)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 84 182)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 98 182)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 112 182)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 196 182)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 210 182)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 238 182)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 280 182)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 308 182)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 350 182)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 378 182)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 392 182)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 406 182)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 420 182)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 434 182)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 448 182)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 28 196)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 42 196)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 56 196)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 70 196)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 84 196)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 112 196)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 140 196)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 154 196)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 308 196)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 336 196)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 392 196)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 406 196)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 420 196)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 434 196)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 448 196)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 42 210)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 56 210)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 84 210)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 98 210)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 112 210)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 140 210)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 168 210)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 182 210)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 196 210)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 224 210)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 238 210)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 280 210)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 294 210)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 350 210)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 364 210)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 392 210)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 420 210)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 434 210)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 14 224)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 28 224)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 42 224)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 70 224)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 84 224)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 140 224)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 210 224)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 280 224)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 336 224)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 364 224)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 392 224)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 420 224)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 434 224)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 462 224)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 42 238)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 70 238)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 98 238)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 112 238)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 126 238)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 140 238)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 224 238)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 280 238)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 294 238)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 364 238)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 378 238)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 392 238)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 420 238)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 448 238)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 14 252)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 28 252)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 56 252)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 70 252)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 126 252)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 140 252)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 154 252)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 182 252)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 196 252)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 224 252)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 238 252)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 280 252)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 294 252)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 322 252)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 350 252)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 378 252)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 392 252)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 406 252)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 420 252)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 448 252)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 462 252)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 28 266)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 42 266)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 56 266)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 84 266)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 98 266)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 112 266)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 126 266)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 140 266)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 154 266)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 168 266)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 210 266)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 238 266)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 252 266)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 308 266)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 336 266)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 364 266)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 378 266)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 392 266)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 420 266)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 434 266)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 462 266)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 42 280)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 70 280)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 84 280)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 112 280)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 140 280)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 168 280)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 182 280)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 210 280)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 224 280)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 280 280)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 294 280)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 322 280)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 336 280)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 350 280)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 378 280)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 420 280)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 434 280)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 462 280)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 98 294)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 112 294)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 154 294)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 168 294)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 196 294)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 252 294)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 294 294)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 322 294)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 350 294)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 364 294)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 420 294)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 448 294)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 462 294)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 14 308)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 168 308)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 196 308)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 252 308)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 294 308)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 322 308)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 364 308)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 378 308)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 392 308)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 406 308)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 420 308)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 14 322)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 42 322)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 56 322)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 84 322)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 98 322)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 112 322)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 140 322)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 154 322)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 182 322)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 196 322)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 252 322)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 294 322)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 350 322)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 378 322)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 448 322)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 462 322)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 14 336)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 42 336)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 70 336)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 84 336)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 112 336)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 126 336)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 154 336)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 182 336)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 196 336)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 224 336)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 238 336)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 252 336)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 392 336)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 406 336)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 434 336)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 448 336)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 462 336)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 14 350)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 28 350)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 42 350)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 56 350)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 70 350)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 84 350)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 98 350)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 112 350)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 126 350)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 154 350)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 182 350)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 196 350)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 280 350)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 350 350)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 364 350)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 378 350)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 392 350)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 406 350)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 126 364)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 154 364)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 182 364)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 280 364)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 322 364)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 336 364)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 350 364)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 406 364)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 126 378)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 140 378)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 168 378)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 210 378)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 224 378)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 252 378)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 280 378)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 294 378)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 308 378)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 322 378)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 350 378)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 378 378)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 406 378)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 140 392)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 154 392)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 182 392)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 196 392)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 210 392)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 280 392)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 336 392)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 350 392)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 406 392)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 420 392)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 434 392)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 448 392)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 126 406)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 140 406)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 154 406)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 196 406)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 210 406)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 224 406)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 252 406)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 266 406)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 280 406)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 294 406)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 308 406)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 336 406)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 350 406)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 364 406)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 378 406)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 392 406)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 406 406)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 448 406)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 126 420)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 154 420)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 168 420)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 182 420)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 196 420)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 252 420)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 308 420)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 350 420)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 364 420)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 392 420)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 434 420)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 448 420)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 140 434)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 196 434)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 210 434)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 238 434)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 252 434)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 294 434)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 322 434)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 336 434)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 350 434)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 406 434)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 448 434)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 462 434)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 140 448)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 154 448)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 224 448)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 266 448)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 280 448)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 322 448)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 378 448)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 434 448)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 448 448)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 462 448)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 140 462)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 182 462)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 210 462)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 224 462)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 238 462)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 266 462)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 280 462)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 350 462)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 406 462)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 434 462)"
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "#000"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15 15h70v70H15z",
    style: {
      fill: "none"
    },
    transform: "matrix(.98 0 0 .98 14 14)"
  }), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M97.3 14H14v98h98V14H97.3zm0 83.3H28.7V28.7h68.6v68.6z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "#000"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15 15h70v70H15z",
    style: {
      fill: "none"
    },
    transform: "matrix(.98 0 0 .98 378 14)"
  }), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M461.3 14H378v98h98V14h-14.7zm0 83.3h-68.6V28.7h68.6v68.6z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "#000"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15 15h70v70H15z",
    style: {
      fill: "none"
    },
    transform: "matrix(.98 0 0 .98 14 378)"
  }), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M97.3 378H14v98h98v-98H97.3zm0 83.3H28.7v-68.6h68.6v68.6z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.42 0 0 .42 42 42)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.42 0 0 .42 406 42)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.42 0 0 .42 42 406)"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEjectingMOonCertexQr);
export default __webpack_public_path__ + "static/media/EjectingMOonCertexQR.2e64c609bce1d16fe0b3de8af8e0745f.svg";
export { ForwardRef as ReactComponent };